import cn from 'classnames';
import React from 'react';

export interface CheckboxProps {
  checked: boolean;
  children: React.ReactNode;
  disabled?: boolean;
  onChange: () => void;
}

const noop = () => {};

export const S2Checkbox: React.FC<CheckboxProps> = ({
  children,
  checked,
  disabled,
  onChange = noop,
}) => {
  return (
    <label
      className={cn('flex space-x-2 items-center font-sans text-gray-900', {
        'cursor-pointer': !disabled,
        'cursor-not-allowed opacity-80': disabled,
      })}
    >
      <input
        type="checkbox"
        className={cn('form-checkbox rounded-sm cursor-pointer', {
          'text-gray-900': checked,
          'border-2 border-gray-900': !checked,
        })}
        checked={checked}
        onChange={disabled ? noop : onChange}
      />

      <span>{children}</span>
    </label>
  );
};
